export interface IVectronState {
  integrationStatus: boolean;
  websocketStatus: boolean;
  lastConnectionAt?: string;
}